import { render, staticRenderFns } from "./Setting-list-questions.vue?vue&type=template&id=42f932cc"
import script from "./Setting-list-questions.vue?vue&type=script&lang=js"
export * from "./Setting-list-questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports